<template>
  <div>
    <div class="container">
      <div class="box">
        <a
          class="sidebar"
          href="https://pgbayarind.id/"
        >
          <div class="bg-logo"></div>
          <div style="position:absolute;">
            <LogoImage
              width="140"
              height="55"
            />
          </div>
        </a>
        <div class="content">
          <slot />
        </div>
      </div>
    </div>
    <portal-target name="modal" />
    <!-- <ModalDialog
      :value="doubleLogin"
      title="Multiple Login Detected"
      text="User already login in another device, please check your email to see the details"
      :showButton="false"
      :showNo="false"
      yesText="OK"
      @yesClicked="preventLogin"
    /> -->
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

import LogoImage from '@/assets/logo/logo-alt.svg';
import ModalDialog from '@/components/ModalDialog.vue';

@Component({
  components: {
    LogoImage,
    ModalDialog,
  },
})
export default class AuthLayout extends Vue {
  doubleLogin = false;

  preventLogin() {
    this.doubleLogin = false;
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100vh;
  background: url("~@/assets/auth-background.svg?external") bottom center
    no-repeat;
  background-size: contain;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box {
  background: $white;
  border-radius: 9px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.16);
  overflow: hidden;
  display: flex;

  .sidebar {
    background: linear-gradient(45deg, #0056a4 -10%, #0668c2 20%, #0c7ce2 50%);
    width: 350px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 768px) {
      display: none;
    }
    .bg-logo {
      content: "";
      background: url("~@/assets/logo/logob.png");
      position: absolute;
      left: 10%;
      width: 90%;
      height: 100%;
      background-size: cover;
      background-repeat: no-repeat;
    }
  }

  .content {
    padding: 20px 40px;
  }
}
</style>
